import React from 'react';
import PropTypes from 'prop-types';
import Form from 'partial/form/Form';
import FormPhoto from 'partial/form/FormPhoto';
import FormInput from 'partial/form/FormInput';
import Button from 'partial/components/Button';
import FormSelect from 'partial/form/FormSelect';
import { showDrawer } from 'partial/components/Modal';
import { useCreateChannel, useUpdateChannel } from '../hooks';
import { transformChannel } from '../transformers';

export const openChannelModal = (title, data, onSuccess) => {
  showDrawer({
    size: 'xs',
    title,
    content: (onClose) => (
      <ChannelModal data={data} onClose={onClose} onSuccess={onSuccess} />
    ),
  });
};

const CATEGORY_OPTIONS = [
  { label: 'Banks', value: 'Banks' },
  { label: 'eWallet', value: 'eWallet' },
  { label: 'Debit/Credit', value: 'Debit/Credit' },
];

function ChannelModal({ data, onClose, onSuccess }) {
  const isNew = !data?.id;
  const [form, setForm] = React.useState(data);
  const [isCreate, create] = useCreateChannel();
  const [isUpdate, update] = useUpdateChannel();
  const handleSubmit = () => {
    if (isNew) {
      create(form, (newData) => {
        onClose();
        onSuccess(newData);
      });
      return;
    }
    update(data?.id, form, onClose);
  };
  return (
    <Form className="divide-y divide-gray-200" onSubmit={handleSubmit}>
      <div>
        <div className="py-3 col-span-3 h-full">
          <FormPhoto
            className="h-24 w-40 rounded-lg"
            imgClassName="object-contain object-center"
            name="logo"
            onChange={setForm}
            value={form.logo}
            label="Logo"
            crop="free"
            resize="256x"
          />
        </div>
        {isNew ? (
          <div className="mb-3">
            <FormInput
              name="code"
              onChange={setForm}
              value={form.code}
              label="Code"
              required
            />
          </div>
        ) : null}
        <div className="mb-3">
          <FormSelect
            name="category"
            onChange={setForm}
            value={form.category}
            label="Category"
            required
            placeholder="- Select Category -"
            options={CATEGORY_OPTIONS}
          />
        </div>
        <div className="mb-3">
          <FormInput
            name="name"
            onChange={setForm}
            value={form.name}
            label="Name"
            required
          />
        </div>
        <div className="mb-3">
          <FormInput
            name="address"
            onChange={setForm}
            value={form.address}
            label="Address"
          />
        </div>
        <div className="mb-3">
          <FormInput
            name="fee"
            onChange={setForm}
            value={form.fee}
            label="Fee"
          />
        </div>
      </div>
      <div className="pt-5">
        <div className="flex justify-end">
          <Button
            type="submit"
            primary
            size="lg"
            disabled={isCreate || isUpdate}
          >
            {isNew ? 'Add' : 'Save'}
          </Button>
        </div>
      </div>
    </Form>
  );
}

ChannelModal.defaultProps = {
  data: transformChannel(),
  onSuccess: false,
};

ChannelModal.propTypes = {
  data: PropTypes.instanceOf(Object),
  onSuccess: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  onClose: PropTypes.func.isRequired,
};

export default ChannelModal;
